<template>
  <div>
    <header id="masthead" class="registration episSpace">
      <div class="wp1200 flex">
        <a class="logo" href></a>
        <ul>
          <li>
            <span class="dot" v-bind:class="{ active: isActive ,'completed' :isCompleted}"></span>
            <span class="line" v-bind:class="{ 'nextStep': isNextStep}"></span>
          </li>
          <li>
            <span class="dot" v-bind:class="{ active: isActive ,'completed' :isCompleted}"></span>
            <span class="line" v-bind:class="{ 'nextStep': isNextStep}"></span>
          </li>
          <li>
            <span class="dot" v-bind:class="{ active: isActive ,'completed' :isCompleted}"></span>
            <span class="line" v-bind:class="{ 'nextStep': isNextStep}"></span>
          </li>
          <li>
            <span class="dot" v-bind:class="{ active: isActive ,'completed' :isCompleted}"></span>
            <span class="line" v-bind:class="{ 'nextStep': isNextStep}"></span>
          </li>
          <li>
            <span class="dot" v-bind:class="{ active: isActive ,'completed' :isCompleted}"></span>
          </li>
        </ul>
      </div>
    </header>
    <div v-if="onBoardingpage == 1">
      <BasicOnBoarding></BasicOnBoarding>
    </div>

    <div v-if="onBoardingpage == 2">
      <AddressOnBoarding></AddressOnBoarding>
    </div>

    <div v-if="onBoardingpage == 3">
      <EducationOnBoarding></EducationOnBoarding>
    </div>

    <div v-if="onBoardingpage == 4">
      <StatusOnBoarding></StatusOnBoarding>
    </div>

    <div v-if="onBoardingpage == 5">
      <HouseHoldOnBoarding></HouseHoldOnBoarding>
    </div>
  </div>
</template>
<script>
import BasicOnBoarding from "./OnBoarding/BasicOnBoarding";
import HouseHoldOnBoarding from "./OnBoarding/HouseHoldOnBoarding";
import AddressOnBoarding from "./OnBoarding/AddressOnBoarding";
import EducationOnBoarding from "./OnBoarding/EducationOnBoarding";
import StatusOnBoarding from "./OnBoarding/StatusOnBoarding";

export default {
  data() {
    return {
      isCompleted: true,
      isActive: true,
      isNextStep: true,
      onBoardingpage:1,
      notCompleted: true,
    };
  },
  components: {
    BasicOnBoarding,
    HouseHoldOnBoarding,
    AddressOnBoarding,
    EducationOnBoarding,
    StatusOnBoarding,
  },
  mounted() {},
  methods: {},
};
</script>
<style>
</style>